export const enum VersionComparisonResult {
  CURRENT_VERSION_HIGHER_THAN_DEPLOYED = "CURRENT_VERSION_HIGHER_THAN_DEPLOYED",
  CURRENT_VERSION_LOWER_THAN_DEPLOYED = "CURRENT_VERSION_LOWER_THAN_DEPLOYED",
  VERSIONS_MATCH = "VERSIONS_MATCH",
}
